import css from "styled-jsx/css";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";

export const TAB_LINE_HEIGHT = 40;

export const componentStyles = css.global`
  .timeline-titled-tabs-component {
    max-width: ${`${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px`};
    margin: auto;

    .full-paragraph-wrapper {
      margin-bottom: 48px;
    }

    display: flex;
    align-items: center;
    justify-content: center;

    .vertical-tabs {
      width: 100%;
      gap: 20px;
      justify-content: space-between;

      .desktop-wrapper {
        width: 100%;

        .vertical-tabs-desktop-component {
          width: 85%;
          padding: 0;

          .vertical-tabs-wrapper {
            .vertical-tabs {
              .content {
                padding-top: 0;
                justify-content: center;
                flex: 1;

                .asset-and-text {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  align-items: stretch;
                  justify-content: space-between;

                  .asset-inner {
                    flex-grow: 1;
                    overflow: hidden;

                    img {
                      max-height: 100%;
                      height: 100%;
                      max-width: 100%;
                      width: 100%;
                      object-fit: contain;
                    }
                  }

                  .title-wrapper {
                    justify-content: center;
                    flex-shrink: 0;
                    overflow: auto;
                    display: flex;
                    align-items: end;

                    .asset-title {
                      text-align: center;
                      line-height: 24px;
                      height: fit-content;
                      align-items: center;
                      font-size: 1rem;
                    }
                  }
                }
              }

              .tabs {
                width: fit-content;
                padding-top: 0;

                .tabs-wrapper {
                  .vertical-tab {
                    font-size: 1rem;

                    &.tab-title {
                      cursor: auto;
                    }

                    &.nested-tab {
                      height: ${`${TAB_LINE_HEIGHT}px`};
                      gap: 40px;

                      &.active {
                        gap: 36px;

                        .tab-label {
                          font-weight: 700;
                        }
                      }
                    }

                    &.active {
                      .vertical-tab-timeline {
                        border-left: 3px solid;
                      }
                    }

                    .vertical-tab-timeline {
                      height: 100%;
                      margin-right: 10px;
                      border: 1px solid;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
